function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,31.372549%,13.333333%)",
      fillOpacity: 1
    },
    d: "M 2.285156 2.285156 L 22.855469 2.285156 L 22.855469 22.855469 L 2.285156 22.855469 Z M 2.285156 2.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,64.313725%,93.72549%)",
      fillOpacity: 1
    },
    d: "M 2.285156 25.144531 L 22.855469 25.144531 L 22.855469 45.714844 L 2.285156 45.714844 Z M 2.285156 25.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(49.803922%,72.941176%,0%)",
      fillOpacity: 1
    },
    d: "M 25.144531 2.285156 L 45.714844 2.285156 L 45.714844 22.855469 L 25.144531 22.855469 Z M 25.144531 2.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,72.54902%,0%)",
      fillOpacity: 1
    },
    d: "M 25.144531 25.144531 L 45.714844 25.144531 L 45.714844 45.714844 L 25.144531 45.714844 Z M 25.144531 25.144531 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftAvatar);
export default __webpack_public_path__ + "static/media/microsoft-avatar.343c003cd24a0f3baa87a2926195b851.svg";
export { ForwardRef as ReactComponent };